import { pickRandom } from '../util';
import Base from './base';
export class DurableTrait extends Base {
    constructor() {
        super(...arguments);
        this.name = 'Durable';
        this.description = 'Take half damage from physical attacks, but can never dodge';
    }
}
export class StubbornTrait extends Base {
    constructor() {
        super(...arguments);
        this.name = 'Stubborn';
        this.description = 'Take 3x damage from all sources, when knocked out, gain full life at the beginning of the following turn, and move first';
    }
}
export class HardHittingTrait extends Base {
    constructor() {
        super(...arguments);
        this.name = 'Hard Hitting';
        this.description = 'Deal double physical damage, but miss half the time';
    }
}
export class EndlessManaTrait extends Base {
    constructor() {
        super(...arguments);
        this.name = 'Endless Mana';
        this.description = 'Creature\'s mana pool is cut in half. Every turn, replenish mana pool';
    }
}
export class BuffSharingTrait extends Base {
    constructor() {
        super(...arguments);
        this.name = 'Buff Sharing';
        this.description = 'All buffs and debuffs to this creature are shared with the rest of the party';
    }
}
export const AllTraits = {
    DurableTrait,
    StubbornTrait,
    HardHittingTrait,
    EndlessManaTrait,
    BuffSharingTrait,
};
export class TraitsGenerator {
    static generateFromCode(code) {
        const { [TraitsGenerator.key]: traits } = JSON.parse(code);
        return traits.map(trait => new AllTraits[trait]());
    }
    static generateTraitsCode(num) {
        const traits = [];
        while (traits.length < num) {
            const randomTrait = pickRandom(Object.keys(AllTraits));
            if (!traits.includes(randomTrait))
                traits.push(randomTrait);
        }
        return JSON.stringify({
            [TraitsGenerator.key]: traits,
        });
    }
}
TraitsGenerator.key = 'traits';
